import { getExpenses } from "@/api/expenses/get-Expenses";
import { useQuery } from "@tanstack/react-query";
import { usePageState, useSetPage } from "../utils/paginationStates";
import { useSelectedMonth, useSelectedYear } from "./expenseStates";

// Custom hook to fetch expenses
export const fetchExpenses = () => {
  const { selectedMonth } = useSelectedMonth();
  const { selectedYear } = useSelectedYear();

  const { pageSize } = usePageState();
  const { currentPage } = useSetPage();

  // Fetch expenses using react-query
  const {
    data: expenses,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["expenses", currentPage, pageSize, selectedMonth, selectedYear],
    queryFn: () =>
      getExpenses(currentPage, pageSize, selectedMonth, selectedYear),
  });

  return {
    expenses,
    isLoading,
    error,
    currentPage,
  };
};
